import axios from 'axios';

/**
 * Shared HTTP transport used by API modules. Per-call options (response type,
 * status handling, headers) stay at the call site so host-specific behavior is explicit.
 */
export const apiTransport = axios.create();
